"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OIDC_FLOW_TYPE_SUPPORT = void 0;
exports.isOidcFlowTypeSupported = isOidcFlowTypeSupported;
const signupFlows_1 = require("./signupFlows");
// Whether OIDC (Google / Microsoft) signup supports a given signup flow type. Shared so the UI and
// the API read one map: the UI hides the OIDC buttons for an unsupported flow type, and the API
// rejects an OIDC verify/complete request carrying one (api/src/utils/oidcFlowTypeGate.ts).
//
// Keyed by the SignupFlowType enum, so adding a flow type without deciding how OIDC treats it
// fails tsc. `false` means hide the OIDC buttons.
exports.OIDC_FLOW_TYPE_SUPPORT = {
    // Plain self-service trial; OIDC is the reference implementation of this.
    [signupFlows_1.SignupFlowType.Default]: true,
    // Special-cased in oidcSignupController (region allowlist, welcome email, activation source).
    [signupFlows_1.SignupFlowType.CortexCodeCLI]: true,
    // Flow type is carried in the OIDC complete request and drives the same server behavior as the
    // regular flow; the lab/template params that give these meaning are handled params.
    [signupFlows_1.SignupFlowType.Lab]: true,
    [signupFlows_1.SignupFlowType.CortexRestApi]: true,
    // Only an `owner` (a handled param) distinguishes it.
    [signupFlows_1.SignupFlowType.AccountExecutive]: true,
    // Behavior is keyed purely off the flow type (trial length and budget in utilityFunctions.ts,
    // Streamlit landing page in DeploymentService.ts, Salesforce referral source and trial id,
    // activation source), and the flow type is carried in the OIDC complete request.
    [signupFlows_1.SignupFlowType.Startup]: true,
    [signupFlows_1.SignupFlowType.Student]: true,
    [signupFlows_1.SignupFlowType.Learn]: true,
    [signupFlows_1.SignupFlowType.Streamlit]: true,
    // Not yet enabled for OIDC. The Salesforce DEVELOPERS tag is derived from the flow type on the
    // server (separate PR), and flipping this to true is a deliberate follow-up that also needs the
    // registry and contract-test updates.
    [signupFlows_1.SignupFlowType.Developer]: false,
    // The params that give these meaning (eng, listing, program) are blocking.
    [signupFlows_1.SignupFlowType.SalesAssisted]: false,
    [signupFlows_1.SignupFlowType.Listing]: false,
    // OIDC only treats strict CortexCodeCLI as a Cortex flow, and never claims the program.
    [signupFlows_1.SignupFlowType.CocoSubscriptionPromo]: false,
    // AWS Marketplace, Azure and GCP marketplace flows never ran through OIDC.
    [signupFlows_1.SignupFlowType.AwsOnDemand]: false,
    [signupFlows_1.SignupFlowType.AwsCapacity]: false,
    [signupFlows_1.SignupFlowType.AwsOnDemandAddSubscription]: false,
    [signupFlows_1.SignupFlowType.Azure]: false,
    [signupFlows_1.SignupFlowType.Gcp]: false,
    // The page itself renders "not found" for this flow type.
    [signupFlows_1.SignupFlowType.Unknown]: false,
};
function isOidcFlowTypeSupported(flowType) {
    return exports.OIDC_FLOW_TYPE_SUPPORT[flowType] === true;
}
//# sourceMappingURL=oidcSupport.js.map